import type { FC } from "react"

import PaymentTermsDisplay from "./PaymentTermsDisplay"

import type { CompanyAccountingTerm } from "@/graphql/codegen/graphql"

interface Props {
  vendorPaymentTerm?: CompanyAccountingTerm
}

export const VendorPaymentTermItem: FC<Props> = ({ vendorPaymentTerm }) => {
  return <PaymentTermsDisplay name='Vendor Payment Terms' value={vendorPaymentTerm?.paymentTerm?.name ?? ""} />
}
